import { SystemIcon } from "@storeblocks/icon";
import { Brand } from "@storebrand-digital/insurance-stepper";
import { Partner } from "Store/partners/partnerInterfaces";
import React from "react";
import { stbColors } from "./Storebrand/storebrandColors";

export const getBrandingForStepper = (themeId: string): Brand => {
  switch (themeId) {
    case Partner.AFAG:
    case Partner.LEGEFORENINGEN:
    case Partner.TANNLEGEFORENINGEN:
    case Partner.VETERINARENE:
    case Partner.ECONA:
    case Partner.NATURVITERNE:
    case Partner.LEKTORLAGET:
    case Partner.PSYKOLOGFORENINGEN:
    case Partner.SAMFUNNSVITERNE:
    case Partner.SAMFUNNSOKONOMENE:
    case Partner.COOP:
    case Partner.HUSEIERNE:
    case Partner.DANSKE_BANK:
    case Partner.STOREBRAND:
      return Brand.SOFT_REBRAND;
    default:
      return Brand.DEFAULT;
  }
};

export const getStepCompleteIconForStepper = (
  themeId: string,
): React.ReactElement<any, string | React.JSXElementConstructor<any>> => {
  switch (themeId) {
    case Partner.AFAG:
    case Partner.LEGEFORENINGEN:
    case Partner.TANNLEGEFORENINGEN:
    case Partner.VETERINARENE:
    case Partner.ECONA:
    case Partner.NATURVITERNE:
    case Partner.LEKTORLAGET:
    case Partner.PSYKOLOGFORENINGEN:
    case Partner.SAMFUNNSVITERNE:
    case Partner.SAMFUNNSOKONOMENE:
    case Partner.STOREBRAND:
    case Partner.COOP:
    case Partner.DANSKE_BANK:
    case Partner.HUSEIERNE:
      return (
        <SystemIcon
          name="check"
          size={16}
          style={{ color: stbColors.selection.main }}
        />
      );
    default:
      return <SystemIcon name="check" size={16} style={{ color: "#1c818d" }} />;
  }
};
